<template>
  <div class="legend">
    <div class="legend__wrapper" v-for="label in labels" :key="label.name">
      <svg
        :width="width"
        :height="height"
        viewBox="0 0 100 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="svg"
      >
        <circle cx="50" cy="50" r="50" :fill="dotColors[label.name]"/>
      </svg>
      <div class="text">
        {{ label.value }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    labels: {
      type: Array,
      required: true,
    },
    dotColors: {
      type: Object,
      required: true,
    },
    height: {
      type: String,
      default: '11',
    },
    width: {
      type: String,
      default: '10',
    },
  },
};
</script>
<style scoped>
.legend {
  font-size: 12px;
  font-weight: 500;
  font-family: Lato;
  color: #778699;
  height: 28px;
  display: flex;
  align-items: center;
}

.legend__wrapper {
  font-size: 12px;
  font-weight: 500;
  font-family: Lato;
  color: #778699;
  display: flex;
  align-items: center;
}

.text {
  padding-left: 8px;
  text-transform: uppercase;
}

.svg {
  padding-left: 16px;
}
</style>
